<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCommonModalStore } from '@/stores/commonModalStore'
import CommonButton from '@/components/common/button/CommonButton.vue'
import { BModal } from 'bootstrap-vue-next'

const commonModalStore = useCommonModalStore()
const {
  isOpen,
  size,
  title,
  body,
  okTitle,
  cancelTitle,
  okOnly,
  autofocusButton,
  okColor,
  centered
} = storeToRefs(commonModalStore)
</script>

<template>
  <BModal
    v-model="isOpen"
    :size="size"
    :title="title"
    :body="body"
    :ok-title="okTitle"
    :cancel-title="cancelTitle"
    :ok-only="okOnly"
    :autofocus-button="autofocusButton"
    :no-header-close="true"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @ok="commonModalStore.ok"
    @cancel="commonModalStore.cancel"
    class="fs-5"
    :centered="centered"
  >
    <div v-html="body"></div>

    <template v-if="!okOnly" #cancel="{ cancel }">
      <CommonButton size="sm" variant="secondary" @click="cancel()" class="fs-5 px-3">{{
        cancelTitle
      }}</CommonButton>
    </template>
    <template #ok="{ ok }">
      <CommonButton size="sm" :variant="okColor" @click="ok()" class="fs-5 px-3">{{
        okTitle
      }}</CommonButton>
    </template>
  </BModal>
</template>

<style lang="scss" scoped>
:deep(.modal-title) {
  font-size: 3.5rem;
}
</style>
